import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";
import MDBox from "components/MDBox";
import ComplexStatisticsCard from "features/Cards/StatisticsCards/ComplexStatisticsCard";
import { nmsMenus } from "globals/configuration/nms";
import { Link } from "react-router-dom";
import Icon from "@mui/material/Icon";
import UCNotificationItem from "application/components/UCNotificationItem";
import { useMaterialUIController, setActivePage, setSearchText } from "context";
import { hmsAdminMenus } from "globals/configuration/hmsAdmin";
import { ivrMenus } from "globals/configuration/ivr/menu";
import { adminMenus } from "globals/configuration/admin";
import { nodeMenus } from "globals/configuration/nodes";
import Menu from "@mui/material/Menu";
import { surakshaMenu } from "globals/configuration/suraksha";
import { callCenterMenus } from "globals/configuration/call-center/menu";
import { ucNotificationMenus } from "globals/configuration/ucNotification";
import AuthenticationService from "application/modules/authentication/AuthenticationService";
import { application } from "globals/endpoints";
import { nodeConfigurationMenus } from "globals/configuration/callServer";
import { voicePickerMenus } from "globals/configuration/voice-Picker";
import CTLIfram from "../CTLifram";
import paMenu from "globals/configuration/paMenu";
import { groupAdminMenu } from "globals/configuration/groupAdminMenus";
import { CMSReportMenu } from "globals/configuration/CMSReportMenu";
import { mediaCenterMenus } from "globals/configuration/mediaCenter";
import { MenuItem } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import { realTimeMenu } from "globals/configuration/realTimeMenu";
import { taskManagementSystem } from "globals/configuration/taskManagementSystem";
import { geofenceMenus } from "globals/configuration/geofence";
import { ExtensionReportMenus } from "globals/configuration/reports/ExtensionReports";
import { customucMenu } from "globals/configuration/customeucMenu";
import { EmsMenu } from "globals/configuration/EMSMenu";
import { actionCodeMenus } from "globals/configuration/pbxServiceMenu";
import { OCconfigurationMenu } from "globals/configuration/OCConfiguration";
import { ServerBackupMenu } from "globals/configuration/serverBackupMenu";
import { CodeBlueMenu } from "globals/configuration/codeBlue";
import { CodeBlueViewerMenu } from "globals/configuration/codeBlueViewer";
import { userMenus } from "globals/configuration/user-management";
import { kanAdminMenus } from "globals/configuration/kanAdminMenu";
import { userDefinedWidgetMenus } from "globals/configuration/nmsDashboard";
import { reportMenus } from "globals/configuration/reports";
import { DashboardConfigMenu } from "globals/configuration/DashboardConfigMenu";
import WidgetConfigMenu from "globals/configuration/WidgetConfigMenu";
import { cdrs } from "globals/configuration/cdrs";
import { viewerMenus } from "globals/configuration/reports/viewerMenus";
import { billingUserMenus } from "globals/configuration/reports/billingUserMenus";
import { extensionMenus } from "globals/configuration/extension";
import DirectCallCenterMenu from "globals/configuration/DirectCallcenterPage";
import { jsonFileCreationMenu } from "globals/configuration/DynamicFormMenu";
import { newVoicePickerMenu } from "globals/configuration/DynamicFormMenu/VoicePicker";
import { getCallCenterConfigurationsMenu } from "globals/configuration/callCenterConfigurationMenu";
import { BillingReportMenu } from "globals/configuration/BillingReportMenu";
import { getQueryBaseReports } from "globals/configuration/queryBaseReports";
import { operatorUserMenus } from "globals/configuration/queryBaseReports/operatorUserMenus";

const Attributes = {
  enableAddButton: false,
  enableApiAccess: AuthenticationService.allowDashboardConfigMenus()
    ? true
    : false,
  modes: [],
};

function CTLMenuDashboard({ onLoad }) {
  const CallCenterConfigurationsMenu = getCallCenterConfigurationsMenu();
  const queryBaseReports = getQueryBaseReports();
  const [openMenu, setOpenMenu] = useState(false);
  const [openExtensionMenu, setOpenExtensionMenu] = useState(false);
  const [openGroupMenu, setOpenGroupMenu] = useState(false);
  const [openNmsMenu, setOpenNmsMenu] = useState(false);
  const [openNmsViewerMenu, setOpenNmsViewerMenu] = useState(false);
  const [openBillingUserReportsMenu, setOpenBillingUserReportsMenu] =
    useState(false);
  const [openDashboardConfigMenu, setOpenDashboardConfigMenu] = useState(false);
  const [openWidgetConfigMenu, setOpenWidgetConfigMenu] = useState(false);
  const [openReportsMenu, setOpenReportsMenu] = useState(false);
  const [openCallCenterMenu, setOpenCallCenterMenu] = useState(false);
  const [openUserMenu, setOpenUserMenu] = useState(false);
  const [openActionCodeMenu, setOpenActionCodeMenu] = useState(false);
  const [openCodeBlueMenu, setOpenCodeBlueMenu] = useState(false);
  const [openOcMenu, setOpenOcMenu] = useState(false);

  const [openCDRSMenu, setOpenCDRSMenu] = useState(false);
  const [openUserDefinedWidgetMenu, setOpenUserDefinedWidgetMenu] =
    useState(false);
  const [counts, setCounts] = useState([]);
  const [intervalId, setIntervalId] = useState(null);
  const [selectedGroupItem, setSelectedGroupItem] = useState(null);
  const [pathUrl, setPathUrl] = useState("");
  const [openIfram, setOpenIfram] = useState(false);

  const [MenuDynamic, setGroupMenu] = useState([]);

  const [openSubMenu, setOpenSubMenu] = useState(null);
  const [SubMenuOpen, setSubMenuOpen] = useState(false);

  const [openQueryMenu,setOpenQueryMenu]=useState(false)

  const handleOpenSubMenu = (menu) => {
    const isOpen = openSubMenu === menu.key;
    setOpenSubMenu(isOpen ? null : menu.key);
    setSubMenuOpen(!isOpen);
  };

  const applicationMode = AuthenticationService.getAppMode();

  const MODE = {
    PRODUCTION: 0,
    DEMO: 1,
    TESTING: 2,
  };

  const isMenuVisibleByMode = (menu) => {
    if (menu.disabled) return false;

    if (applicationMode === MODE.PRODUCTION) {
      return menu.productionReady && !menu.demoReady && !menu.testingReady;
    }

    if (applicationMode === MODE.DEMO) {
      return (menu.productionReady || menu.demoReady) && !menu.testingReady;
    }

    if (applicationMode === MODE.TESTING) {
      return menu.productionReady || menu.demoReady || menu.testingReady;
    }

    return false;
  };

  const getModeBadgeLabel = () => {
    if (applicationMode === MODE.TESTING) return "TEST";
    if (applicationMode === MODE.DEMO) return "DEMO";
    return undefined;
  };

  const isMenuReadyForCurrentMode = (menu) => {
    if (!menu) return false;

    if (applicationMode === MODE.TESTING) {
      return menu.testingReady === true;
    }

    if (applicationMode === MODE.DEMO) {
      return menu.demoReady === true;
    }

    return false;
  };

  const getMenuModeBadge = (menu) =>
    isMenuReadyForCurrentMode(menu) ? getModeBadgeLabel() : undefined;

  const getMenusModeBadge = (menus = []) =>
    menus.some((menu) => isMenuReadyForCurrentMode(menu))
      ? getModeBadgeLabel()
      : undefined;

  const shouldShowTestingIndicator = (menu) =>
    applicationMode === MODE.TESTING && isMenuReadyForCurrentMode(menu);

  const shouldShowDemoIndicator = (menu) =>
    applicationMode === MODE.DEMO && isMenuReadyForCurrentMode(menu);

  useEffect(() => setGroupMenu(AuthenticationService.getGroupMenus()), []);

  const filteredCallCenterConfigurationsMenu =
    CallCenterConfigurationsMenu.filter((menu) =>
      MenuDynamic?.find(
        (MenuDynamic) =>
          MenuDynamic.name === "Call Center" &&
          MenuDynamic.menus.some(
            (item) =>
              item.menuName === menu.name &&
              (item.product === "main" || item.product === "both"),
          ),
      ),
    );

  const CallCenterConfigurationsMenus =
    filteredCallCenterConfigurationsMenu?.length == 0
      ? CallCenterConfigurationsMenu.map((menu) => ({
          icon: menu.icon,
          key: menu.key,
          name: menu.name,
          url: menu.url,
          description: menu.description,
          productionReady: menu.productionReady,
          demoReady: menu.demoReady,
          testingReady: menu.testingReady,
        }))
      : filteredCallCenterConfigurationsMenu.map((menu) => ({
          icon: menu.icon,
          key: menu.key,
          name: menu.name,
          url: menu.url,
          description: menu.description,
          productionReady: menu.productionReady,
          demoReady: menu.demoReady,
          testingReady: menu.testingReady,
        }));

  CallCenterConfigurationsMenus.sort((a, b) => {
    const callCenterMenu = MenuDynamic.find(
      (menu) => menu.name === "Call Center",
    );
    const sequenceA =
      callCenterMenu?.menus.find((item) => item.menuName === a.name)
        ?.sequence || 0;
    const sequenceB =
      callCenterMenu?.menus.find((item) => item.menuName === b.name)
        ?.sequence || 0;
    return sequenceA - sequenceB;
  });

  const handleOpenMenu = (event) => setOpenMenu(event.currentTarget);
  const handleOpenExtensionMenu = (event) =>
    setOpenExtensionMenu(event.currentTarget);
  const handleCloseExtensionMenu = () => setOpenExtensionMenu(false);
  const handleOpenGroupMenu = (event, group) => {
    setOpenGroupMenu(event.currentTarget);
    setSelectedGroupItem(group);
  };

  const handleCloseGroupMenu = () => {
    setOpenGroupMenu(null);
    setSelectedGroupItem(null);
  };

  function handleClose() {
    setOpenIfram(false);
  }
  const handleOpenDashboardConfigMenu = (event) =>
    setOpenDashboardConfigMenu(event.currentTarget);
  const handleCloseDashboardConfigMenu = () =>
    setOpenDashboardConfigMenu(false);

  const handleOpenWidgetConfigMenu = (event) =>
    setOpenWidgetConfigMenu(event.currentTarget);
  const handleCloseWidgetConfigMenu = () => setOpenWidgetConfigMenu(false);
  const handleCloseMenu = () => setOpenMenu(false);
  const handleOpenNmsMenu = (event) => setOpenNmsMenu(event.currentTarget);
  const handleCloseNmsMenu = () => setOpenNmsMenu(false);
  const handleOpenNmsViewerMenu = (event) =>
    setOpenNmsViewerMenu(event.currentTarget);
  const handleCloseNmsViewerMenu = () => setOpenNmsViewerMenu(false);
  const handleOpenBillingUserReportsMenu = (event) =>
    setOpenBillingUserReportsMenu(event.currentTarget);
  const handleCloseBillingUserReportsMenu = () =>
    setOpenBillingUserReportsMenu(false);
  const handleOpenReportMenu = (event) =>
    setOpenReportsMenu(event.currentTarget);
  const handleCloseReportMenu = () => setOpenReportsMenu(false);
  const handleOpenCallCenterMenu = (event) =>
    setOpenCallCenterMenu(event.currentTarget);
  const handleCloseCallCenterMenu = () => setOpenCallCenterMenu(false);

  const handleOpenUserMenu = (event) => setOpenUserMenu(event.currentTarget);
  const handleCloseUserMenu = () => setOpenUserMenu(false);

  const handleOpenActionCodeMenu = (event) =>
    setOpenActionCodeMenu(event.currentTarget);
  const handleOpenCodeBlueMenu = (event) =>
    setOpenCodeBlueMenu(event.currentTarget);
  const handleCloseActionCodeMenu = () => setOpenActionCodeMenu(false);
  const handleCloseCodeBlueMenu = () => setOpenCodeBlueMenu(false);
  const handleOpenOcMenu = (event) => setOpenOcMenu(event.currentTarget);
  const handleCloseOcMenu = () => setOpenOcMenu(false);

  const handleOpenCDRSMenu = (event) => setOpenCDRSMenu(event.currentTarget);
  const handleCloseCDRSMenu = () => setOpenCDRSMenu(false);

  const [openCMS, setOpenCMS] = useState(false);
  const handleOpenCMSMenu = (event) => setOpenCMS(event.currentTarget);
  const handleCloseCMSSMenu = () => setOpenCMS(false);

  const [openBilling, setOpenBilling] = useState(false);
  const handleOpenBillingMenu = (event) => setOpenBilling(event.currentTarget);
  const handleCloseBillingMenu = () => setOpenBilling(false);

  const [openPicker, setOpenPicker] = useState(false);
  const handleOpenVoicePickerMenu = (event) =>
    setOpenPicker(event.currentTarget);
  const handleCloseVoicePickerMenu = () => setOpenPicker(false);

  // Task Management Menu
  const [openTask, setOpenTask] = useState(false);
  const handleOpenTaskMenu = (event) => setOpenTask(event.currentTarget);
  const handleCloseTaskMenu = () => setOpenTask(false);

  const handleOpenQueryBaseMenu = (event) => setOpenQueryMenu(event.currentTarget);
  const handleQueryBaseMenuClose =()=>setOpenQueryMenu(false);
  
  const handleopenUserDefinedWidgetMenu = (event) =>
    setOpenUserDefinedWidgetMenu(event.currentTarget);
  const handleCloseNmsdashboardMenu = () => setOpenUserDefinedWidgetMenu(false);
  const [controller, dispatch] = useMaterialUIController();
  const { activePage, darkMode } = controller;

  const menuPaperProps = {
    style: {
      maxHeight: "60vh",
      overflowY: "auto",
      backgroundColor: darkMode ? "#1e1e1e" : "#ffffff",
      backgroundImage: "none",
      border: darkMode ? "1px solid rgba(255,255,255,0.12)" : "1px solid rgba(0,0,0,0.12)",
    },
  };

  const MenuClicked = (menu) => {
    activePage.key = menu.key;
    activePage.name = menu.name;
    activePage.url = menu.url;
    activePage.description = menu.description;
    setActivePage(dispatch, activePage);
    setOpenMenu(false);
    setSearchText(dispatch, "");
  };

  let enableSystemMenu = false;
  let enableHMSmenu = false;
  let enableNMSmenu = false;
  let enablesurakshaMenu = false;
  let enableIvrmenu = false;
  let enablecallCenterMenus = false;
  let enablecallCenterConfigurationsMenus = false;
  let enablevoicePickerMenus = false;
  let enableTaskMenus = false;
  let enablenodeMenus = false;
  let enablerealTimeMenus = false;
  let enableMediaCenterMenus = false;
  let enableGeofencingMenus = false;
  let enableUcMenus = false;
  let enableCustomUcMenus = false;
  let enableEmsMenus = false;
  let enableKanAdminMenu = false;
  let enableDashboardConfigMenu = false;
  let enableWidgetConfigMenu = false;
  let enableCdrsMenu = false;
  let enableCMSMenu = false;
  let enableBillingMenu = false;
  let enableReportMenu = false;
  let enableViewerMenu = false;
  let enableBillingUserReportsMenu = false;
  let enableDirectCallCenter = false;
  let enablepaMenu = false;
  let enableGroupAdminMenu = false;
  let userManagementMenu = false;
  let enablePBXServiceMenu = false;
  let OCConfigurationMenu = false;
  let enableServerBackupMenu = false;
  let enableCodeBlueMenu = false;
  let enableJsonFileCreationMenus = false;
  let enableNewVoicePickerMenus = false;
  let enableQueryBaseReports= false

  userMenus.map((menu) => {
    if (isMenuVisibleByMode(menu) && AuthenticationService.allowApollo()) {
      userManagementMenu = true;
    }
  });
  userMenus.map((menu) => {
    if (
      isMenuVisibleByMode(menu) &&
      AuthenticationService.allowManagerMenus()
    ) {
      userManagementMenu = true;
    }
  });

  actionCodeMenus.map((menu) => {
    if (isMenuVisibleByMode(menu) && AuthenticationService.allowAdminMenus()) {
      enablePBXServiceMenu = true;
    }
  });

  CodeBlueMenu.map((menu) => {
    if (
      isMenuVisibleByMode(menu) &&
      (AuthenticationService.allowAdminMenus() ||
        AuthenticationService.allowCodeBlueViewerMenus())
    ) {
      enableCodeBlueMenu = true;
    }
  });
  OCconfigurationMenu.map((menu) => {
    if (isMenuVisibleByMode(menu) && AuthenticationService.allowAdminMenus()) {
      OCConfigurationMenu = true;
    }
  });

  ExtensionReportMenus.map((menu) => {
    if (isMenuVisibleByMode(menu) && AuthenticationService.allowApollo()) {
      enableReportMenu = true;
    }
  });

  adminMenus.map((menu) => {
    if (isMenuVisibleByMode(menu) && AuthenticationService.allowAdminMenus()) {
      enableSystemMenu = true;
    }
  });

  viewerMenus.map((menu) => {
    if (
      isMenuVisibleByMode(menu) &&
      (AuthenticationService.allownmsViewerMenus() ||
        AuthenticationService.allownmsMenus())
    ) {
      enableViewerMenu = true;
    }
  });

  reportMenus.map((menu) => {
    if (isMenuVisibleByMode(menu) && AuthenticationService.allowAdminMenus()) {
      enableReportMenu = true;
    }
  });

  hmsAdminMenus.map((menu) => {
    if (
      isMenuVisibleByMode(menu) &&
      AuthenticationService.allowhmsAdminMenus()
    ) {
      enableHMSmenu = true;
    }
  });
  nmsMenus.map((menu) => {
    if (
      isMenuVisibleByMode(menu) &&
      (AuthenticationService.allowAdminMenus() ||
        AuthenticationService.allownmsMenus() ||
        AuthenticationService.allownmsAdminMenus())
    ) {
      enableNMSmenu = true;
    }
  });


  // For Dashboard Configuration
  DashboardConfigMenu.map((menu) => {
    if (
      isMenuVisibleByMode(menu) &&
      AuthenticationService.allowDashboardConfigMenus()
    ) {
      enableDashboardConfigMenu = true;
    }
  });
  // For Widget Configuration
  WidgetConfigMenu.map((menu) => {
    if (
      isMenuVisibleByMode(menu) &&
      AuthenticationService.allowDashboardConfigMenus()
    ) {
      enableWidgetConfigMenu = true;
    }
  });
  kanAdminMenus.map((menu) => {
    if (
      isMenuVisibleByMode(menu) &&
      AuthenticationService.allowkanAdminMenus()
    ) {
      enableKanAdminMenu = true;
    }
  });
  surakshaMenu.map((menu) => {
    if (
      isMenuVisibleByMode(menu) &&
      AuthenticationService.allowsurakshaMenus()
    ) {
      enablesurakshaMenu = true;
    }
  });
  ivrMenus.map((menu) => {
    if (isMenuVisibleByMode(menu) && AuthenticationService.allowAdminMenus()) {
      enableIvrmenu = true;
    }
  });

  cdrs.map((menu) => {
    if (isMenuVisibleByMode(menu) && AuthenticationService.allowAdminMenus()) {
      enableCdrsMenu = true;
    }
  });

  // For CMS Reports Menu

  CMSReportMenu.map((menu) => {
    if (
      isMenuVisibleByMode(menu) &&
      (AuthenticationService.allowAdminMenus() ||
        AuthenticationService.allowDepartmentHeadMenu())
    ) {
      enableCMSMenu = true;
    }
  });

  BillingReportMenu.map((menu) => {
    if (
      isMenuVisibleByMode(menu) &&
      (AuthenticationService.allowAdminMenus() ||
        AuthenticationService.allowBillingMenus())
    ) {
      enableBillingMenu = true;
    }
  });

  billingUserMenus.map((menu) => {
    if (isMenuVisibleByMode(menu) && AuthenticationService.allowBillingMenus()) {
      enableBillingUserReportsMenu = true;
    }
  });

  callCenterMenus.map((menu) => {
    if (isMenuVisibleByMode(menu) && AuthenticationService.allowAdminMenus()) {
      enablecallCenterMenus = true;
    }
  });

  /// Direct only CallCenter Access
  DirectCallCenterMenu.map((menu) => {
    if (
      isMenuVisibleByMode(menu) &&
      AuthenticationService.allowCallcenterTabMenus()
    ) {
      enableDirectCallCenter = true;
    }
  });
  /// Direct only CallCenter Access
  paMenu.map((menu) => {
    if (isMenuVisibleByMode(menu) && AuthenticationService.allowPAMenu()) {
      enablepaMenu = true;
    }
  });

  CallCenterConfigurationsMenus.map((menu) => {
    if (isMenuVisibleByMode(menu) && AuthenticationService.allowAdminMenus()) {
      enablecallCenterConfigurationsMenus = true;
    }
  });

  CallCenterConfigurationsMenus.map((menu) => {
    if (
      isMenuVisibleByMode(menu) &&
      AuthenticationService.allowManagerMenus()
    ) {
      enablecallCenterConfigurationsMenus = true;
    }
  });
  voicePickerMenus.map((menu) => {
    if (
      isMenuVisibleByMode(menu) &&
      (AuthenticationService.allowAdminMenus() ||
        AuthenticationService.allowVoicePickerMenus())
    ) {
      enablevoicePickerMenus = true;
    }
  });

  // Task Management Menu
  taskManagementSystem.map((menu) => {
    if (
      isMenuVisibleByMode(menu) &&
      (AuthenticationService.allowAdminMenus() ||
        AuthenticationService.allowTaskManager())
    ) {
      enableTaskMenus = true;
    }
  });

  nodeMenus.map((menu) => {
    if (isMenuVisibleByMode(menu) && AuthenticationService.allowAdminMenus()) {
      enablenodeMenus = true;
    }
  });


  const queryBaseReportsSource = AuthenticationService.isOperatorAdminOnlyUser()
    ? operatorUserMenus
    : queryBaseReports;
  queryBaseReportsSource.map((menu) => {
    if (
      isMenuVisibleByMode(menu) &&
      (AuthenticationService.allowAdminMenus() ||
        AuthenticationService.allowOperatorAdminMenus())
    ) {
      enableQueryBaseReports = true;
    }
  });

  jsonFileCreationMenu.map((menu) => {
    if (
      isMenuVisibleByMode(menu) &&
      AuthenticationService.allowManagerMenus()
    ) {
      enableJsonFileCreationMenus = true;
    }
  });

  newVoicePickerMenu.map((menu) => {
    if (
      isMenuVisibleByMode(menu) &&
      AuthenticationService.allowManagerMenus()
    ) {
      enableNewVoicePickerMenus = true;
    }
  });

  realTimeMenu.map((menu) => {
    if (isMenuVisibleByMode(menu) && AuthenticationService.allowAdminMenus()) {
      enablerealTimeMenus = true;
    }
  });

  mediaCenterMenus.map((menu) => {
    if (isMenuVisibleByMode(menu) && AuthenticationService.allowAdminMenus()) {
      enableMediaCenterMenus = true;
    }
  });
  geofenceMenus.map((menu) => {
    if (isMenuVisibleByMode(menu) && AuthenticationService.allowAdminMenus()) {
      enableGeofencingMenus = true;
    }
  });

  ServerBackupMenu.map((menu) => {
    if (isMenuVisibleByMode(menu) && AuthenticationService.allowAdminMenus()) {
      enableServerBackupMenu = true;
    }
  });

  groupAdminMenu.forEach((menu) => {
    if (isMenuVisibleByMode(menu) && AuthenticationService.allowGroupAdmin()) {
      enableGroupAdminMenu = true;
    }
  });

  ucNotificationMenus.map((menu) => {
    if (isMenuVisibleByMode(menu) && AuthenticationService.allowUCMenus()) {
      enableUcMenus = true;
    }
  });

  customucMenu.map((menu) => {
    if (
      isMenuVisibleByMode(menu) &&
      AuthenticationService.allowCustomucMenu()
    ) {
      enableCustomUcMenus = true;
    }
  });

  customucMenu.map((menu) => {
    if (isMenuVisibleByMode(menu) && AuthenticationService.allowEamsMenu()) {
      enableEmsMenus = true;
    }
  });

  useEffect(() => {
    Attributes && onLoad(Attributes);
  }, []);

  //Admin Menu
  const renderMenu = () => (
    <Menu
      anchorEl={openMenu}
      
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      open={Boolean(openMenu)}
      onClose={handleCloseMenu}
      
      PaperProps={menuPaperProps}
    >
      {AuthenticationService.allowAdminMenus() &&
        adminMenus.map((menu) => {
          if (isMenuVisibleByMode(menu)) {
            if (menu.type == "divider") {
              return <Divider key={menu.key} />;
            } else {
              return (
                <Link key={menu.key} onClick={() => MenuClicked(menu)} to="#">
                  <UCNotificationItem
                    icon={<Icon>{menu.icon}</Icon>}
                    title={menu.name}
                    badgeContent={shouldShowTestingIndicator(menu)}
                    demoContent={shouldShowDemoIndicator(menu)}
                  />
                </Link>
              );
            }
          }
        })}
    </Menu>
  );

  const renderActionCodeMenu = () => (
    <Menu
      anchorEl={openActionCodeMenu}
      
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      open={Boolean(openActionCodeMenu)}
      onClose={handleCloseActionCodeMenu}
      
      PaperProps={menuPaperProps}
    >
      {AuthenticationService.allowAdminMenus() &&
        actionCodeMenus.map((menu) => {
          if (isMenuVisibleByMode(menu)) {
            if (menu.type === "divider") {
              return <Divider key={menu.key} />;
            } else {
              return (
                <Link key={menu.key} onClick={() => MenuClicked(menu)} to="#">
                  <UCNotificationItem
                    icon={<Icon>{menu.icon}</Icon>}
                    title={menu.name}
                    badgeContent={shouldShowTestingIndicator(menu)}
                    demoContent={shouldShowDemoIndicator(menu)}
                  />
                </Link>
              );
            }
          }
        })}
    </Menu>
  );

  const renderCodeBlueMenu = () => (
    <Menu
      anchorEl={openCodeBlueMenu}
      
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      open={Boolean(openCodeBlueMenu)}
      onClose={handleCloseCodeBlueMenu}
      
      PaperProps={menuPaperProps}
    >
      {AuthenticationService.allowAdminMenus() &&
        CodeBlueMenu.map((menu) => {
          if (
            isMenuVisibleByMode(menu) 
          ) {
            if (menu.type === "divider") {
              return <Divider key={menu.key} />;
            } else {
              return (
                <Link key={menu.key} onClick={() => MenuClicked(menu)} to="#">
                  <UCNotificationItem
                    icon={<Icon>{menu.icon}</Icon>}
                    title={menu.name}
                    badgeContent={shouldShowTestingIndicator(menu)}
                    demoContent={shouldShowDemoIndicator(menu)}
                  />
                </Link>
              );
            }
          }
        })}
    </Menu>
  );

  const renderCodeBlueViewerMenu = () => (
    <Menu
      anchorEl={openCodeBlueMenu}
      
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      open={Boolean(openCodeBlueMenu)}
      onClose={handleCloseCodeBlueMenu}
      
      PaperProps={menuPaperProps}
    >
      {AuthenticationService.allowCodeBlueViewerMenus() &&
        CodeBlueViewerMenu.map((menu) => {
          if (isMenuVisibleByMode(menu)) {
            if (menu.type === "divider") {
              return <Divider key={menu.key} />;
            } else {
              return (
                <Link key={menu.key} onClick={() => MenuClicked(menu)} to="#">
                  <UCNotificationItem
                    icon={<Icon>{menu.icon}</Icon>}
                    title={menu.name}
                    badgeContent={shouldShowTestingIndicator(menu)}
                    demoContent={shouldShowDemoIndicator(menu)}
                  />
                </Link>
              );
            }
          }
        })}
    </Menu>
  );

  const renderCMSMenu = () => (
    <Menu
      anchorEl={openCMS}
      
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      open={Boolean(openCMS)}
      onClose={handleCloseCMSSMenu}
      
      PaperProps={menuPaperProps}
    >
      {(AuthenticationService.allowAdminMenus() ||
        AuthenticationService.allowDepartmentHeadMenu()) &&
        CMSReportMenu.map((menu) => {
          if (isMenuVisibleByMode(menu)) {
            if (menu.type === "divider") {
              return <Divider key={menu.key} />;
            } else {
              return (
                <Link key={menu.key} onClick={() => MenuClicked(menu)} to="#">
                  <UCNotificationItem
                    icon={<Icon>{menu.icon}</Icon>}
                    title={menu.name}
                    badgeContent={shouldShowTestingIndicator(menu)}
                    demoContent={shouldShowDemoIndicator(menu)}
                  />
                </Link>
              );
            }
          }
        })}
    </Menu>
  );

  const renderBillingMenu = () => (
    <Menu
      anchorEl={openBilling}
      
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      open={Boolean(openBilling)}
      onClose={handleCloseBillingMenu}
      
      PaperProps={menuPaperProps}
    >
      {(AuthenticationService.allowAdminMenus() ||
        AuthenticationService.allowBillingMenus()) &&
        BillingReportMenu.map((menu) => {
          if (isMenuVisibleByMode(menu)) {
            if (menu.type === "divider") {
              return <Divider key={menu.key} />;
            } else {
              return (
                <Link key={menu.key} onClick={() => MenuClicked(menu)} to="#">
                  <UCNotificationItem
                    icon={
                      <>
                        <Icon>{menu.icon}</Icon>
                      </>
                    }
                    title={menu.name}
                    badgeContent={shouldShowTestingIndicator(menu)}
                    demoContent={shouldShowDemoIndicator(menu)}
                  />
                </Link>
              );
            }
          }
        })}
    </Menu>
  );

  const renderVoicePickerMenu = () => (
    <Menu
      anchorEl={openPicker}
      
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      open={Boolean(openPicker)}
      onClose={handleCloseVoicePickerMenu}
      
      PaperProps={menuPaperProps}
    >
      {AuthenticationService.allowAdminMenus() &&
        voicePickerMenus.map((menu) => {
          if (isMenuVisibleByMode(menu)) {
            if (menu.type == "divider") {
              return <Divider key={menu.key} />;
            } else {
              return (
                <Link key={menu.key} onClick={() => MenuClicked(menu)} to="#">
                  <UCNotificationItem
                    icon={<Icon>{menu.icon}</Icon>}
                    title={menu.name}
                    badgeContent={shouldShowTestingIndicator(menu)}
                    demoContent={shouldShowDemoIndicator(menu)}
                  />
                </Link>
              );
            }
          }
        })}
      {AuthenticationService.allowVoicePickerMenus() &&
        voicePickerMenus.map((menu) => {
          if (isMenuVisibleByMode(menu)) {
            if (menu.type == "divider") {
              return <Divider key={menu.key} />;
            } else {
              return (
                <Link key={menu.key} onClick={() => MenuClicked(menu)} to="#">
                  <UCNotificationItem
                    icon={<Icon>{menu.icon}</Icon>}
                    title={menu.name}
                    badgeContent={shouldShowTestingIndicator(menu)}
                    demoContent={shouldShowDemoIndicator(menu)}
                  />
                </Link>
              );
            }
          }
        })}
    </Menu>
  );

  const renderTaskMenu = () => (
    <Menu
      anchorEl={openTask}
      
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      open={Boolean(openTask)}
      onClose={handleCloseTaskMenu}
      
      PaperProps={menuPaperProps}
    >
      {(AuthenticationService.allowAdminMenus() ||
        AuthenticationService.allowTaskManager()) &&
        taskManagementSystem.map((menu) => {
          if (isMenuVisibleByMode(menu)) {
            if (menu.type == "divider") {
              return <Divider key={menu.key} />;
            } else {
              return (
                <Link key={menu.key} onClick={() => MenuClicked(menu)} to="#">
                  <UCNotificationItem
                    icon={<Icon>{menu.icon}</Icon>}
                    title={menu.name}
                    badgeContent={shouldShowTestingIndicator(menu)}
                    demoContent={shouldShowDemoIndicator(menu)}
                  />
                </Link>
              );
            }
          }
        })}
    </Menu>
  );

  const renderQueryBaseMenu = () => (
    <Menu
      anchorEl={openQueryMenu}
      
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      open={Boolean(openQueryMenu)}
      onClose={handleQueryBaseMenuClose}
      
      PaperProps={menuPaperProps}
    >
      {(AuthenticationService.allowAdminMenus() ||
        AuthenticationService.allowOperatorAdminMenus()) &&
        (AuthenticationService.isOperatorAdminOnlyUser()
          ? operatorUserMenus
          : queryBaseReports
        ).map((menu) => {
          if (isMenuVisibleByMode(menu)) {
            if (menu.type == "divider") {
              return <Divider key={menu.key} />;
            } else {
              return (
                <Link key={menu.key} onClick={() => MenuClicked(menu)} to="#">
                  <UCNotificationItem
                    icon={<Icon>{menu.icon}</Icon>}
                    title={menu.name}
                    badgeContent={shouldShowTestingIndicator(menu)}
                    demoContent={shouldShowDemoIndicator(menu)}
                  />
                </Link>
              );
            }
          }
        })}
    </Menu>
  );

  const renderExtensionMenu = () => (
    <Menu
      anchorEl={openExtensionMenu}
      
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      open={Boolean(openExtensionMenu)}
      onClose={handleCloseExtensionMenu}
      
      PaperProps={menuPaperProps}
    >
      {AuthenticationService.allowAdminMenus() &&
        extensionMenus.map((menu) => {
          if (isMenuVisibleByMode(menu)) {  
            const isSubMenuOpen = openSubMenu === menu.key;
            if (menu.type === "divider") {
              return <Divider key={menu.key} />;
            } else {
              return (
                <div key={menu.key}>
                  <Link
                    onClick={() =>
                      menu.submenu ? handleOpenSubMenu(menu) : MenuClicked(menu)
                    }
                    to="#"
                    style={{ display: "block" }}
                  >
                    <UCNotificationItem
                      icon={<Icon>{menu.icon}</Icon>}
                      title={
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "end",
                            alignItems: "center",
                          }}
                        >
                          <span>{menu.name}</span>
                          {menu.submenu &&
                            (isSubMenuOpen ? (
                              <ArrowDropDownIcon
                                style={{
                                  position: "absolute",
                                  right: 10,
                                  color: "red",
                                }}
                                fontSize="medium"
                              />
                            ) : (
                              <ArrowDropUpIcon
                                style={{
                                  position: "absolute",
                                  right: 10,
                                  color: "red",
                                }}
                                fontSize="medium"
                              />
                            ))}
                        </div>
                      }
                    />
                  </Link>
                  {isSubMenuOpen && (
                    <div style={{ paddingLeft: 16 }}>
                      {menu.submenu
                        ?.filter((submenu) => isMenuVisibleByMode(submenu))
                        .map((submenu) => (
                          <MenuItem
                            key={submenu.key}
                            onClick={() => MenuClicked(submenu)}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              paddingLeft: "35px",
                            }}
                          >
                            <Icon style={{ marginRight: "8px" }}>
                              {submenu.icon}
                            </Icon>
                            {submenu.name}
                          </MenuItem>
                        ))}
                    </div>
                  )}
                </div>
              );
            }
          }
          return null;
        })}
    </Menu>
  );

  const renderuserDefinedWidgetMenus = () => (
    <Menu
      anchorEl={openUserDefinedWidgetMenu}
      
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      sx={{ mt: -1 }}
      PaperProps={menuPaperProps}
      open={Boolean(openUserDefinedWidgetMenu)}
      onClose={handleCloseNmsdashboardMenu}
    >
      {AuthenticationService.allowAdminMenus() &&
        userDefinedWidgetMenus.map((menu) => {
          if (isMenuVisibleByMode(menu)) {
            if (menu.type == "divider") {
              return <Divider key={menu.key} />;
            } else {
              return (
                <Link key={menu.key} onClick={() => MenuClicked(menu)} to="#">
                  <UCNotificationItem
                    icon={<Icon>{menu.icon}</Icon>}
                    title={menu.name}
                    badgeContent={shouldShowTestingIndicator(menu)}
                    demoContent={shouldShowDemoIndicator(menu)}
                  />
                </Link>
              );
            }
          }
        })}
    </Menu>
  );

  const renderNmsMenu = () => (
    <Menu
      anchorEl={openNmsMenu}
      
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      sx={{ mt: -1 }}
      PaperProps={menuPaperProps}
      open={Boolean(openNmsMenu)}
      onClose={handleCloseNmsMenu}
    >
      {(AuthenticationService.allowAdminMenus() ||
        AuthenticationService.allownmsMenus() ||
        AuthenticationService.allownmsAdminMenus()) &&
        nmsMenus.map((menu) => {
          if (
             isMenuVisibleByMode(menu) 
          ) {
            if (menu.type === "divider") {
              return <Divider key={menu.key} />;
            }

            return (
              <Link
                key={menu.key}
                onClick={
                  menu.submenu
                    ? handleopenUserDefinedWidgetMenu
                    : () => MenuClicked(menu)
                }
                to="#"
              >
                <UCNotificationItem
                  icon={<Icon>{menu.icon}</Icon>}
                  title={menu.name}
                  badgeContent={shouldShowTestingIndicator(menu)}
                  demoContent={shouldShowDemoIndicator(menu)}
                />
              </Link>
            );
          }
        })}
    </Menu>
  );

  const renderNmsViewerMenu = () => (
    <Menu
      anchorEl={openNmsViewerMenu}

      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      open={Boolean(openNmsViewerMenu)}
      onClose={handleCloseNmsViewerMenu}

      PaperProps={menuPaperProps}
    >
      {(AuthenticationService.allownmsViewerMenus() ||
        AuthenticationService.allownmsMenus()) &&
        viewerMenus.map((menu) => {
          if (
             isMenuVisibleByMode(menu)
          ) {
            if (menu.type === "divider") {
              return <Divider key={menu.key} />;
            }
            return (
              <Link key={menu.key} onClick={() => MenuClicked(menu)} to="#">
                <UCNotificationItem
                  icon={<Icon>{menu.icon}</Icon>}
                  title={menu.name}
                  badgeContent={shouldShowTestingIndicator(menu)}
                  demoContent={shouldShowDemoIndicator(menu)}
                />
              </Link>
            );
          }
        })}
    </Menu>
  );

  const renderBillingUserReportsMenu = () => (
    <Menu
      anchorEl={openBillingUserReportsMenu}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      open={Boolean(openBillingUserReportsMenu)}
      onClose={handleCloseBillingUserReportsMenu}
      PaperProps={menuPaperProps}
    >
      {AuthenticationService.allowBillingMenus() &&
        billingUserMenus.map((menu) => {
          if (isMenuVisibleByMode(menu)) {
            if (menu.type === "divider") {
              return <Divider key={menu.key} />;
            }
            return (
              <Link key={menu.key} onClick={() => MenuClicked(menu)} to="#">
                <UCNotificationItem
                  icon={<Icon>{menu.icon}</Icon>}
                  title={menu.name}
                  badgeContent={shouldShowTestingIndicator(menu)}
                  demoContent={shouldShowDemoIndicator(menu)}
                />
              </Link>
            );
          }
        })}
    </Menu>
  );

  const renderDashboardConfigMenu = () => (
    <Menu
      anchorEl={openDashboardConfigMenu}
      
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      
      PaperProps={menuPaperProps}
      open={Boolean(openDashboardConfigMenu)}
      onClose={handleCloseDashboardConfigMenu}
    >
      {AuthenticationService.allowDashboardConfigMenus() &&
        DashboardConfigMenu.map((menu) => {
          if (
             isMenuVisibleByMode(menu) 
          ) {
            if (menu.type == "divider") {
              return <Divider key={menu.key} />;
            } else {
              return (
                <Link
                  key={menu.key}
                  onClick={
                    menu.submenu
                      ? handleopenUserDefinedWidgetMenu
                      : () => MenuClicked(menu)
                  }
                  to="#"
                >
                  <UCNotificationItem
                    icon={<Icon>{menu.icon}</Icon>}
                    title={menu.name}
                    badgeContent={shouldShowTestingIndicator(menu)}
                    demoContent={shouldShowDemoIndicator(menu)}
                  />
                </Link>
              );
            }
          }
        })}
    </Menu>
  );

  const renderWidgetConfigMenu = () => (
    <Menu
      anchorEl={openWidgetConfigMenu}
      
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      
      PaperProps={menuPaperProps}
      open={Boolean(openWidgetConfigMenu)}
      onClose={handleCloseWidgetConfigMenu}
    >
      {AuthenticationService.allowDashboardConfigMenus() &&
        WidgetConfigMenu.map((menu) => {
          if (isMenuVisibleByMode(menu)) {
            if (menu.type == "divider") {
              return <Divider key={menu.key} />;
            } else {
              return (
                <Link
                  key={menu.key}
                  onClick={
                    menu.submenu
                      ? handleopenUserDefinedWidgetMenu
                      : () => MenuClicked(menu)
                  }
                  to="#"
                >
                  <UCNotificationItem
                    icon={<Icon>{menu.icon}</Icon>}
                    title={menu.name}
                    badgeContent={shouldShowTestingIndicator(menu)}
                    demoContent={shouldShowDemoIndicator(menu)}
                  />
                </Link>
              );
            }
          }
        })}
    </Menu>
  );

  const renderReportMenu = () => (
    <Menu
      anchorEl={openReportsMenu}
      
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      
      PaperProps={menuPaperProps}
      open={Boolean(openReportsMenu)}
      onClose={handleCloseReportMenu}
    >
      {AuthenticationService.allowAdminMenus() &&
        reportMenus.map((menu) => {
          if (isMenuVisibleByMode(menu)) {
            if (menu.type == "divider") {
              return <Divider key={menu.key} />;
            } else {
              return (
                <Link key={menu.key} onClick={() => MenuClicked(menu)} to="#">
                  <UCNotificationItem
                    icon={<Icon>{menu.icon}</Icon>}
                    title={menu.name}
                    badgeContent={shouldShowTestingIndicator(menu)}
                    demoContent={shouldShowDemoIndicator(menu)}
                  />
                </Link>
              );
            }
          }
        })}
    </Menu>
  );

  const renderExtensionReportsMenu = () => (
    <Menu
      anchorEl={openReportsMenu}
      
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      
      PaperProps={menuPaperProps}
      open={Boolean(openReportsMenu)}
      onClose={handleCloseReportMenu}
    >
      {AuthenticationService.allowApollo() &&
        ExtensionReportMenus.map((menu) => {
          if (isMenuVisibleByMode(menu)) {
            if (menu.type == "divider") {
              return <Divider key={menu.key} />;
            } else {
              return (
                <Link key={menu.key} onClick={() => MenuClicked(menu)} to="#">
                  <UCNotificationItem
                    icon={<Icon>{menu.icon}</Icon>}
                    title={menu.name}
                    badgeContent={shouldShowTestingIndicator(menu)}
                    demoContent={shouldShowDemoIndicator(menu)}
                  />
                </Link>
              );
            }
          }
        })}
    </Menu>
  );

  const renderCallCenterMenu = () => (
    <Menu
      anchorEl={openCallCenterMenu}
      
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      
      PaperProps={menuPaperProps}
      open={Boolean(openCallCenterMenu)}
      onClose={handleCloseCallCenterMenu}
    >
      {(AuthenticationService.allowAdminMenus() ||
        AuthenticationService.allowManagerMenus()) &&
        CallCenterConfigurationsMenus.map((menu) => {
          if (isMenuVisibleByMode(menu)) {
            if (menu.type == "divider") {
              return <Divider key={menu.key} />;
            } else {
              return (
                <Link key={menu.key} onClick={() => MenuClicked(menu)} to="#">
                  <UCNotificationItem
                    icon={<Icon>{menu.icon}</Icon>}
                    title={menu.name}
                    badgeContent={shouldShowTestingIndicator(menu)}
                    demoContent={shouldShowDemoIndicator(menu)}
                  />
                </Link>
              );
            }
          }
        })}
    </Menu>
  );

  const renderCallCenterManagerMenu = () => (
    <Menu
      anchorEl={openCallCenterMenu}
      
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      
      PaperProps={menuPaperProps}
      open={Boolean(openCallCenterMenu)}
      onClose={handleCloseCallCenterMenu}
    >
      {AuthenticationService.allowManagerMenus() &&
        CallCenterConfigurationsMenus.map((menu) => {
          if (isMenuVisibleByMode(menu)) {
            if (menu.type == "divider") {
              return <Divider key={menu.key} />;
            } else {
              return (
                <Link key={menu.key} onClick={() => MenuClicked(menu)} to="#">
                  <UCNotificationItem
                    icon={<Icon>{menu.icon}</Icon>}
                    title={menu.name}
                    badgeContent={shouldShowTestingIndicator(menu)}
                    demoContent={shouldShowDemoIndicator(menu)}
                  />
                </Link>
              );
            }
          }
        })}
    </Menu>
  );

  const renderuserManagementMenus = () => (
    <Menu
      anchorEl={openUserMenu}
      
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      
      PaperProps={menuPaperProps}
      open={Boolean(openUserMenu)}
      onClose={handleCloseUserMenu}
    >
      {(AuthenticationService.allowAdminMenus() ||
        AuthenticationService.allowManagerMenus() ||
        AuthenticationService.allowApollo() ||
        AuthenticationService.allowManagerMenus()) &&
        userMenus.map((menu) => {
          if (isMenuVisibleByMode(menu)) {
            if (menu.type == "divider") {
              return <Divider key={menu.key} />;
            } else {
              return (
                <Link key={menu.key} onClick={() => MenuClicked(menu)} to="#">
                  <UCNotificationItem
                    icon={<Icon>{menu.icon}</Icon>}
                    title={menu.name}
                    badgeContent={shouldShowTestingIndicator(menu)}
                    demoContent={shouldShowDemoIndicator(menu)}
                  />
                </Link>
              );
            }
          }
        })}
    </Menu>
  );

  const renderuserManagementRoleMangerMenus = () => (
    <Menu
      anchorEl={openUserMenu}
      
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      
      PaperProps={menuPaperProps}
      open={Boolean(openUserMenu)}
      onClose={handleCloseUserMenu}
    >
      {AuthenticationService.allowManagerMenus() &&
        AuthenticationService.allownmsMenus() &&
        userMenus.map((menu) => {
          if (isMenuVisibleByMode(menu)) {
            if (menu.type == "divider") {
              return <Divider key={menu.key} />;
            } else {
              return (
                <Link key={menu.key} onClick={() => MenuClicked(menu)} to="#">
                  <UCNotificationItem
                    icon={<Icon>{menu.icon}</Icon>}
                    title={menu.name}
                    badgeContent={shouldShowTestingIndicator(menu)}
                    demoContent={shouldShowDemoIndicator(menu)}
                  />
                </Link>
              );
            }
          }
        })}
    </Menu>
  );

  const renderOCconfigurationMenu = () => (
    <Menu
      anchorEl={openOcMenu}
      
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      
      PaperProps={menuPaperProps}
      open={Boolean(openOcMenu)}
      onClose={handleCloseOcMenu}
    >
      {AuthenticationService.allowAdminMenus() &&
        OCconfigurationMenu.map((menu) => {
          if (isMenuVisibleByMode(menu)) {
            if (menu.type == "divider") {
              return <Divider key={menu.key} />;
            } else {
              return (
                <Link key={menu.key} onClick={() => MenuClicked(menu)} to="#">
                  <UCNotificationItem
                    icon={<Icon>{menu.icon}</Icon>}
                    title={menu.name}
                    badgeContent={shouldShowTestingIndicator(menu)}
                    demoContent={shouldShowDemoIndicator(menu)}
                  />
                </Link>
              );
            }
          }
        })}
    </Menu>
  );

  const renderCDRSMenus = () => (
    <Menu
      anchorEl={openCDRSMenu}
      
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      
      PaperProps={menuPaperProps}
      open={Boolean(openCDRSMenu)}
      onClose={handleCloseCDRSMenu}
    >
      {AuthenticationService.allowAdminMenus() &&
        cdrs.map((menu) => {
          if (isMenuVisibleByMode(menu)) {
            if (menu.type == "divider") {
              return <Divider key={menu.key} />;
            } else {
              return (
                <Link key={menu.key} onClick={() => MenuClicked(menu)} to="#">
                  <UCNotificationItem
                    icon={<Icon>{menu.icon}</Icon>}
                    title={menu.name}
                    badgeContent={shouldShowTestingIndicator(menu)}
                    demoContent={shouldShowDemoIndicator(menu)}
                  />
                </Link>
              );
            }
          }
        })}
    </Menu>
  );

  const renderKanAdminMenu = () => (
    <Menu
      anchorEl={openNmsMenu}
      
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      
      PaperProps={menuPaperProps}
      open={Boolean(openNmsMenu)}
      onClose={handleCloseNmsMenu}
    >
      {AuthenticationService.allowkanAdminMenus() &&
        kanAdminMenus.map((menu) => {
          if (isMenuVisibleByMode(menu)) {
            if (menu.type == "divider") {
              return <Divider key={menu.key} />;
            } else {
              return (
                <Link key={menu.key} onClick={() => MenuClicked(menu)} to="#">
                  <UCNotificationItem
                    icon={<Icon>{menu.icon}</Icon>}
                    title={menu.name}
                    badgeContent={shouldShowTestingIndicator(menu)}
                    demoContent={shouldShowDemoIndicator(menu)}
                  />
                </Link>
              );
            }
          }
        })}
    </Menu>
  );

  const fetchNotifications = async () => {
    try {
      const response = await application.post("/uc/countNotification/list");
      const notifications = response.data.data;
      setCounts(notifications);
    } catch (error) {
      console.error("Failed to fetch notifications:", error);
    }
  };

  useEffect(() => {
    let id;
    if (AuthenticationService.allowUCMenus()) {
      fetchNotifications();
      id = setInterval(fetchNotifications, 2000);
      setIntervalId(id);
    }

    return () => {
      if (id) {
        clearInterval(id);
      }
    };
  }, []);

  const getMenuCountByMessageType = (messageType) => {
    const notification = counts.find(
      (notification) => notification.messageType === messageType,
    );
    return notification ? notification.count : 0;
  };

  async function handleOpenManager(urlPath) {
    let urlScheme = window.location.protocol;
    let isDomain = window.location.hostname.toLowerCase().match(/[a-z]/i);
    let host = window.location.host;

    application
      .post("/userToken/create", { createdBy: "API" })
      .then((response) => {
        let urlParts = urlPath.split("/");
        let application = urlParts[0];
        urlParts.shift();
        urlPath = urlParts.join("/");
        let managerURL = `${urlScheme}//${host}/${application}/access?authKey=${response.data.data}&appURL=${urlPath}`;
        console.log(managerURL);
        if (isDomain) {
          setPathUrl(managerURL);
          setOpenIfram(true);
        } else {
          const popupFeatures = "fullscreen=yes resizable=yes,scrollbars=yes";
          window.open(managerURL, ` - ${urlPath}`, popupFeatures);
        }
      })
      .catch((error) => {
        console.log("error: ", error);
      });
  }

  const groupMenu = AuthenticationService.getGroupMenus();

  const renderMenuGroup = () => (
    <Menu
      anchorEl={openGroupMenu}
      anchorReference="anchorEl"
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      open={Boolean(openGroupMenu)}
      onClose={handleCloseGroupMenu}
      
    >
      {selectedGroupItem && (
        <div key={selectedGroupItem.menuGroup}>
          {(Array.isArray(selectedGroupItem?.menus)
            ? selectedGroupItem.menus
            : []
          ).map((menu) => (
            <UCNotificationItem
              key={menu.menuId}
              onClick={() => handleOpenManager(menu.urlPath)}
              icon={<Icon>{menu.icon}</Icon>}
              title={menu.menuName}
            />
          ))}
        </div>
      )}
    </Menu>
  );

  return (
    <MDBox>
      <Grid container spacing={2}>
        {enableSystemMenu && (
          <Grid item xs={12} sm={6} md={4} lg={2.4}>
            <MDBox

              onClick={handleOpenMenu}
            >
              <ComplexStatisticsCard
                badge={getMenusModeBadge(adminMenus)}
                color="secondary"
                icon="supervisor_account"
                title="System Settings"
                menuDescription="Use this to configure and monitor system settings"
              />
            </MDBox>
          </Grid>
        )}
        {enableNMSmenu && (
          <>
            <Grid item xs={12} sm={6} md={4} lg={2.4}>
              <MDBox
  
                onClick={handleOpenNmsMenu}
                >
                <ComplexStatisticsCard
                  badge={getMenusModeBadge(nmsMenus)}
                  color="info"
                  icon="network_check"
                  title="NMS"
                  menuDescription="Use this to configure and monitor your devices"
                />
              </MDBox>
            </Grid>
          </>
        )}

        {enableDashboardConfigMenu && (
          <>
            <Grid item xs={12} sm={6} md={4} lg={2.4}>
              <MDBox
  
                // onClick={handleOpenDashboardConfigMenu}
                onClick={() => MenuClicked(DashboardConfigMenu[0])}
                >
                <ComplexStatisticsCard
                  badge={getMenuModeBadge(DashboardConfigMenu[0])}
                  color="success"
                  icon="perm_data_setting"
                  title="Dashboard-Configuration"
                  menuDescription="Use this to configure and monitor your Dashboard-Configuration "
                />
              </MDBox>
            </Grid>
          </>
        )}

        {enableWidgetConfigMenu && (
          <>
            <Grid item xs={12} sm={6} md={4} lg={2.4}>
              <MDBox
  
                // onClick={handleOpenWidgetConfigMenu}
                onClick={() => MenuClicked(WidgetConfigMenu[0])}
                >
                <ComplexStatisticsCard
                  badge={getMenuModeBadge(WidgetConfigMenu[0])}
                  color="warning"
                  icon="confirmation_number"
                  title="Widget-Configuration"
                  menuDescription="Use this to configure and monitor your Widget-Configuration"
                />
              </MDBox>
            </Grid>
          </>
        )}

        {enableSystemMenu && (
          <Grid item xs={12} sm={6} md={4} lg={2.4}>
            <MDBox

              key={nodeConfigurationMenus[0].key}
              onClick={() => MenuClicked(nodeConfigurationMenus[0])}
            >
              <ComplexStatisticsCard
                badge={getMenuModeBadge(nodeConfigurationMenus[0])}
                color="secondary"
                icon="network_check"
                title="Node Configuration"
                menuDescription="Use this to configure and monitor your call server"
              />
            </MDBox>
          </Grid>
        )}

        {enableKanAdminMenu && (
          <>
            <Grid item xs={12} sm={6} md={4} lg={2.4}>
              <MDBox
  
                onClick={handleOpenNmsMenu}
                >
                <ComplexStatisticsCard
                  // badge={
                  //   applicationMode === MODE.TESTING &&
                  //   nms[0]?.testingReady === true
                  //     ? "TEST"
                  //     : undefined
                  // }
                  color="info"
                  icon="network_check"
                  title="K NMS"
                  menuDescription="Use this to configure and monitor your devices"
                />
              </MDBox>
            </Grid>
          </>
        )}


        {enableJsonFileCreationMenus && (
          <Grid item xs={12} sm={6} md={4} lg={2.4}>
            <MDBox

              key={jsonFileCreationMenu[0].key}
              onClick={() => MenuClicked(jsonFileCreationMenu[0])}
              to="#"
            >
              <ComplexStatisticsCard
                badge={getMenuModeBadge(jsonFileCreationMenu[0])}
                color="info"
                icon="workspaces"
                title="JSON File Creation"
                menuDescription="Use this to configure create a json file for dynamic form"
              />
            </MDBox>
          </Grid>
        )}

        {enableNewVoicePickerMenus && (
          <Grid item xs={12} sm={6} md={4} lg={2.4}>
            <MDBox

              key={newVoicePickerMenu[0].key}
              onClick={() => MenuClicked(newVoicePickerMenu[0])}
              to="#"
            >
              <ComplexStatisticsCard
                badge={getMenuModeBadge(newVoicePickerMenu[0])}
                color="info"
                icon="workspaces"
                title="Voice Picker"
                menuDescription="Use this to configure Voice Picker"
              />
            </MDBox>
          </Grid>
        )}
        {enablerealTimeMenus && (
          <Grid item xs={12} sm={6} md={4} lg={2.4}>
            <MDBox

              key={realTimeMenu[0].key}
              onClick={() => MenuClicked(realTimeMenu[0])}
              to="#"
            >
              <ComplexStatisticsCard
                badge={getMenuModeBadge(realTimeMenu[0])}
                color="info"
                icon="blur_on"
                title="Real Time"
                menuDescription="Real-time data will display here when a call is active"
              />
            </MDBox>
          </Grid>
        )}

        {enableGroupAdminMenu &&
          groupAdminMenu.map((menu, index) => (
            <Grid item xs={12} md={6} lg={3} key={index}>
              <MDBox
  
                onClick={() => MenuClicked(menu)}
                to="#"
                >
                <ComplexStatisticsCard
                  badge={getMenuModeBadge(menu)}
                  color={menu.color}
                  icon={menu.icon}
                  title={menu.name}
                  menuDescription={menu.description}
                />
              </MDBox>
            </Grid>
          ))}

        {enablesurakshaMenu && (
          <Grid item xs={12} sm={6} md={4} lg={2.4}>
            <MDBox

              key={surakshaMenu[0].key}
              onClick={() => MenuClicked(surakshaMenu[0])}
              to="#"
            >
              <ComplexStatisticsCard
                badge={getMenuModeBadge(surakshaMenu[0])}
                color="success"
                icon="map"
                title="Suraksha"
                menuDescription="Use This Map to Monitor Zones & Broadcast messages "
              />
            </MDBox>
          </Grid>
        )}
        {enableHMSmenu && (
          <Grid item xs={12} sm={6} md={4} lg={2.4}>
            <MDBox

              key={hmsAdminMenus[0].key}
              onClick={() => MenuClicked(hmsAdminMenus[0])}
              to="#"
            >
              <ComplexStatisticsCard
                badge={getMenuModeBadge(hmsAdminMenus[0])}
                color="primary"
                icon="hotel"
                title="Hotel"
                menuDescription="Use this to configure and monitor hms functionality"
              />
            </MDBox>
          </Grid>
        )}
        {enableIvrmenu && (
          <Grid item xs={12} sm={6} md={4} lg={2.4}>
            <MDBox

              key={ivrMenus[0].key}
              onClick={() => MenuClicked(ivrMenus[0])}
              to="#"
            >
              <ComplexStatisticsCard
                badge={getMenuModeBadge(ivrMenus[0])}
                color="warning"
                icon="settings_voice"
                title="Auto Attendant"
                menuDescription="Use this to configure IVR (Interactive voice response)"
              />
            </MDBox>
          </Grid>
        )}
        {enablecallCenterMenus && (
          <Grid item xs={12} sm={6} md={4} lg={2.4}>
            <MDBox

              key={callCenterMenus[0].key}
              onClick={() => MenuClicked(callCenterMenus[0])}
              to="#"
            >
              <ComplexStatisticsCard
                badge={getMenuModeBadge(callCenterMenus[0])}
                color="error"
                icon="call"
                title="Call Center"
                menuDescription="Use this to configure and monitor Call center functionality"
              />
            </MDBox>
          </Grid>
        )}

        {enablepaMenu && (
          <Grid item xs={12} sm={6} md={4} lg={2.4}>
            <MDBox

              key={paMenu[0].key}
              onClick={() => MenuClicked(paMenu[0])}
              to="#"
            >
              <ComplexStatisticsCard
                badge={getMenuModeBadge(paMenu[0])}
                color="error"
                icon="report"
                title="Report"
                menuDescription="Use this to Read the report"
              />
            </MDBox>
          </Grid>
        )}
        {enableCMSMenu && (
          <Grid item xs={12} sm={6} md={4} lg={2.4}>
            <MDBox

              onClick={handleOpenCMSMenu}
            >
              <ComplexStatisticsCard
                badge={getMenusModeBadge(CMSReportMenu)}
                color="error"
                icon="device_hub"
                title="CMS Reports"
                menuDescription="Use this to monitor All CMS Reports "
              />
            </MDBox>
          </Grid>
        )}

        {enableBillingMenu && (
          <Grid item xs={12} sm={6} md={4} lg={2.4}>
            <MDBox

              onClick={handleOpenBillingMenu}
            >
              <ComplexStatisticsCard
                badge={getMenusModeBadge(BillingReportMenu)}
                color="primary"
                icon="edit"
                title="Billing Reports"
                menuDescription="Use this to monitor All billing reports."
              />
            </MDBox>
          </Grid>
        )}
        {enableBillingUserReportsMenu && (
          <Grid item xs={12} sm={6} md={4} lg={2.4}>
            <MDBox onClick={handleOpenBillingUserReportsMenu}>
              <ComplexStatisticsCard
                badge={getMenusModeBadge(billingUserMenus)}
                color="primary"
                icon="reports"
                title="Reports"
                menuDescription="Billing CDR, Extension CDR and Feature Extension CDR"
              />
            </MDBox>
          </Grid>
        )}
        {enablevoicePickerMenus && (
          <Grid item xs={12} sm={6} md={4} lg={2.4}>
            <MDBox

              onClick={handleOpenVoicePickerMenu}
            >
              <ComplexStatisticsCard
                badge={getMenusModeBadge(voicePickerMenus)}
                color="success"
                icon="keyboard_voice"
                title="Voice Picker"
                menuDescription="Use this to configure and monitor Voice Picker functionality"
              />
            </MDBox>
          </Grid>
        )}
        {enableTaskMenus && (
          <Grid item xs={12} sm={6} md={4} lg={2.4}>
            <MDBox

              onClick={handleOpenTaskMenu}
            >
              <ComplexStatisticsCard
                badge={getMenusModeBadge(taskManagementSystem)}
                color="success"
                icon="task_icon"
                title="Task Management"
                menuDescription="Use this to configure and monitor Task System"
              />
            </MDBox>
          </Grid>
        )}
        {enableUcMenus &&
          ucNotificationMenus
            .filter(
              (menu) => !AuthenticationService.isUCConferenceMenuHidden(menu.key),
            )
            .map((menu) => (
            <Grid item xs={12} md={6} lg={3} key={menu.key}>
              <MDBox
  
                onClick={() => MenuClicked(menu)}
                to="#"
                >
                <ComplexStatisticsCard
                  badge={
                    getMenuCountByMessageType(menu.messageType) > 0
                      ? getMenuCountByMessageType(menu.messageType)
                      : undefined
                  }
                  color={menu.color}
                  icon={menu.icon}
                  title={menu.name}
                  menuDescription={
                    menu.messageType
                      ? `You have${
                          getMenuCountByMessageType(menu.messageType) > 0
                            ? ` ${getMenuCountByMessageType(
                                menu.messageType,
                              )} new`
                            : " 0"
                        } ${menu.name} notification${
                          getMenuCountByMessageType(menu.messageType) !== 0
                            ? "s"
                            : ""
                        }`
                      : ""
                  }
                />
              </MDBox>
            </Grid>
          ))}

        {enableCustomUcMenus &&
          customucMenu.map((menu) => (
            <Grid item xs={12} md={6} lg={3} key={menu.key}>
              <MDBox
  
                onClick={() => MenuClicked(menu)}
                to="#"
                >
                <ComplexStatisticsCard
                  badge={
                    getMenuCountByMessageType(menu.messageType) > 0
                      ? getMenuCountByMessageType(menu.messageType)
                      : undefined
                  }
                  color={menu.color}
                  icon={menu.icon}
                  title={menu.name}
                  menuDescription={
                    menu.messageType
                      ? `You have${
                          getMenuCountByMessageType(menu.messageType) > 0
                            ? ` ${getMenuCountByMessageType(
                                menu.messageType,
                              )} new`
                            : " 0"
                        } ${menu.name} notification${
                          getMenuCountByMessageType(menu.messageType) !== 0
                            ? "s"
                            : ""
                        }`
                      : ""
                  }
                />
              </MDBox>
            </Grid>
          ))}

        {enableEmsMenus &&
          EmsMenu.map((menu) => (
            <Grid item xs={12} md={6} lg={3} key={menu.key}>
              <MDBox
  
                onClick={() => MenuClicked(menu)}
                to="#"
                >
                <ComplexStatisticsCard
                  badge={
                    getMenuCountByMessageType(menu.messageType) > 0
                      ? getMenuCountByMessageType(menu.messageType)
                      : undefined
                  }
                  color={menu.color}
                  icon={menu.icon}
                  title={menu.name}
                  menuDescription={
                    menu.messageType
                      ? `You have${
                          getMenuCountByMessageType(menu.messageType) > 0
                            ? ` ${getMenuCountByMessageType(
                                menu.messageType,
                              )} new`
                            : " 0"
                        } ${menu.name} notification${
                          getMenuCountByMessageType(menu.messageType) !== 0
                            ? "s"
                            : ""
                        }`
                      : ""
                  }
                />
              </MDBox>
            </Grid>
          ))}
        {enablesurakshaMenu && (
          <Grid item xs={12} sm={6} md={4} lg={2.4}>
            <MDBox

              key={surakshaMenu[0].key}
              onClick={() => MenuClicked(surakshaMenu[0])}
              to="#"
            >
              <ComplexStatisticsCard
                badge={getMenuModeBadge(surakshaMenu[0])}
                color="success"
                icon="map"
                title="Suraksha"
                menuDescription="Use This Map to Monitor Zones & Broadcast messages "
              />
            </MDBox>
          </Grid>
        )}
        {enableReportMenu && (
          <Grid item xs={12} sm={6} md={4} lg={2.4}>
            <MDBox

              onClick={handleOpenReportMenu}
            >
              <ComplexStatisticsCard
                badge={getMenusModeBadge(reportMenus)}
                color="primary"
                icon="reports"
                title="Reports"
                menuDescription="Use this to monitor your billings and reports"
              />
            </MDBox>
          </Grid>
        )}
        {enableViewerMenu && (
          <Grid item xs={12} sm={6} md={4} lg={2.4}>
            <MDBox

              onClick={handleOpenNmsViewerMenu}
            >
              <ComplexStatisticsCard
                badge={getMenusModeBadge(viewerMenus)}
                color="primary"
                icon="reports"
                title="NMS Reports"
                menuDescription="Use this to monitor your billings and reports"
              />
            </MDBox>
          </Grid>
        )}
        {enableSystemMenu && (
          <Grid item xs={12} sm={6} md={4} lg={2.4}>
            <MDBox

              onClick={handleOpenUserMenu}
            >
              <ComplexStatisticsCard
                badge={getMenusModeBadge(userMenus)}
                color="info"
                icon="manage_accounts"
                title="User Management"
                menuDescription="Use this to configure user management"
              />
            </MDBox>
          </Grid>
        )}
        {userManagementMenu && (
          <Grid item xs={12} sm={6} md={4} lg={2.4}>
            <MDBox

              onClick={handleOpenUserMenu}
            >
              <ComplexStatisticsCard
                badge={getMenusModeBadge(userMenus)}
                color="info"
                icon="manage_accounts"
                title="User Management"
                menuDescription="Use this to configure user management"
              />
            </MDBox>
          </Grid>
        )}

        {OCConfigurationMenu && (
          <Grid item xs={12} sm={6} md={4} lg={2.4}>
            <MDBox

              onClick={handleOpenOcMenu}
            >
              <ComplexStatisticsCard
                badge={getMenusModeBadge(OCconfigurationMenu)}
                color="info"
                icon="account_tree"
                title="OC Configuration"
                menuDescription="Use this to configuration for OC Configuration"
              />
            </MDBox>
          </Grid>
        )}
        {enablePBXServiceMenu && (
          <Grid item xs={12} sm={6} md={4} lg={2.4}>
            <MDBox

              onClick={handleOpenActionCodeMenu}
            >
              <ComplexStatisticsCard
                badge={getMenusModeBadge(actionCodeMenus)}
                color="info"
                icon="manage_accounts"
                title="Action Code"
                menuDescription="Use this to configure action code"
              />
            </MDBox>
          </Grid>
        )}
        {enableCodeBlueMenu && (
          <Grid item xs={12} sm={6} md={4} lg={2.4}>
            <MDBox

              onClick={handleOpenCodeBlueMenu}
            >
              <ComplexStatisticsCard
                badge={getMenusModeBadge(CodeBlueMenu)}
                color="error"
                icon="manage_accounts"
                title="Code Blue"
                menuDescription="Use this to configure Code Blue"
              />
            </MDBox>
          </Grid>
        )}
        {enableMediaCenterMenus && (
          <Grid item xs={12} sm={6} md={4} lg={2.4}>
            <MDBox

              key={mediaCenterMenus[0].key}
              onClick={() => MenuClicked(mediaCenterMenus[0])}
              to="#"
            >
              <ComplexStatisticsCard
                badge={getMenuModeBadge(mediaCenterMenus)}
                color="primary"
                icon="display_settings_icon"
                title="Media Center"
                menuDescription="Use this to configure and monitor media center"
              />
            </MDBox>
          </Grid>
        )}

{enableQueryBaseReports && (
          <Grid item xs={12} sm={6} md={4} lg={2.4}>
            <MDBox
              onClick={handleOpenQueryBaseMenu}
            >
              <ComplexStatisticsCard
                badge={getMenuModeBadge(
                  AuthenticationService.isOperatorAdminOnlyUser()
                    ? operatorUserMenus
                    : queryBaseReports,
                )}
                color="primary"
                icon="display_settings_icon"
                title="Agent & Queue Reports"
                menuDescription="Use this to All Call Center Reports"
              />
            </MDBox>
          </Grid>
        )}

        {enableGeofencingMenus && (
          <Grid item xs={12} sm={6} md={4} lg={2.4}>
            <MDBox

              key={geofenceMenus[0].key}
              onClick={() => MenuClicked(geofenceMenus[0])}
              to="#"
            >
              <ComplexStatisticsCard
                badge={getMenuModeBadge(geofenceMenus[0])}
                color="success"
                icon="map_icon"
                title="Geofencing Configuration"
                menuDescription="Use this to configure and monitor Geofencing"
              />
            </MDBox>
          </Grid>
        )}
        {enableServerBackupMenu && (
          <Grid item xs={12} sm={6} md={4} lg={2.4}>
            <MDBox

              key={ServerBackupMenu[0].key}
              onClick={() => MenuClicked(ServerBackupMenu[0])}
              to="#"
            >
              <ComplexStatisticsCard
                badge={getMenuModeBadge(ServerBackupMenu[0])}
                color="error"
                icon="storage_icon"
                title="Server sync"
                menuDescription="Use this to sync your server"
              />
            </MDBox>
          </Grid>
        )}
        {enableSystemMenu && groupMenu &&
          groupMenu
            .filter((group) => Array.isArray(group?.menus) && group.menus.length > 0)
            .map((group) => (
            <Grid item xs={12} md={6} lg={3} key={group.menuGroup}>
              <MDBox
  
                onClick={(event) => handleOpenGroupMenu(event, group)}
                >
                <ComplexStatisticsCard
                  badge={getMenusModeBadge(group.menus)}
                  color="info"
                  icon={group.icon}
                  title={group.name}
                  menuDescription={group.description}
                />
              </MDBox>
            </Grid>
          ))}
        {enableCdrsMenu && (
          <Grid item xs={12} sm={6} md={4} lg={2.4}>
            <MDBox

              onClick={handleOpenCDRSMenu}
              to="#"
            >
              <ComplexStatisticsCard
                badge={getMenuModeBadge(CDRSMenus[0])}
                color="warning"
                icon="graphic_eq_icon"
                title="CDRS"
                menuDescription="Use this to configure CDRS"
              />
            </MDBox>
          </Grid>
        )}

        {AuthenticationService.allowAdminMenus() && (
          <>
            {renderMenuGroup()}
            {renderuserManagementMenus()}
            {renderOCconfigurationMenu()}
            {renderCDRSMenus()}
            {renderuserDefinedWidgetMenus()}
            {renderWidgetConfigMenu()}
            {renderCallCenterMenu()}
            {renderExtensionMenu()}
            {renderVoicePickerMenu()}
            {renderTaskMenu()}
            {renderCMSMenu()}
            {renderActionCodeMenu()}
            {renderCodeBlueMenu()}
            {renderBillingMenu()}
            {renderQueryBaseMenu()}
          </>
        )}
        {!AuthenticationService.allowAdminMenus() &&
          AuthenticationService.allowOperatorAdminMenus() &&
          renderQueryBaseMenu()}
        {AuthenticationService.allowVoicePickerMenus() && (
          <> {renderVoicePickerMenu()}</>
        )}
        {AuthenticationService.allowCodeBlueViewerMenus() && (
          <>{renderCodeBlueViewerMenu()}</>
        )}
        {AuthenticationService.allowTaskManager() && <>{renderTaskMenu()}</>}

        {AuthenticationService.allowApollo() && (
          <>
            {renderuserManagementMenus()}
            {renderExtensionReportsMenu()}
          </>
        )}

        {AuthenticationService.allowManagerMenus() &&
          AuthenticationService.allownmsMenus() && (
            <>
              {renderuserManagementRoleMangerMenus()}
              {renderCallCenterManagerMenu()}
              {renderVoicePickerMenu()}
            </>
          )}

        {(AuthenticationService.allowAdminMenus() ||
          AuthenticationService.allowDepartmentHeadMenu()) && (
          <>{renderCMSMenu()}</>
        )}

        {AuthenticationService.allowAdminMenus() && <>{renderMenuGroup()}</>}
        {(AuthenticationService.allownmsViewerMenus() ||
          AuthenticationService.allownmsMenus()) && (
          <>{renderNmsViewerMenu()}</>
        )}
        {AuthenticationService.allowBillingMenus() && (
          <>
            {renderBillingUserReportsMenu()}
            {!AuthenticationService.allowAdminMenus() && renderBillingMenu()}
          </>
        )}
        {AuthenticationService.allowAdminMenus() && <>{renderMenu()}</>}

        {AuthenticationService.allowAdminMenus() && <>{renderReportMenu()}</>}

        {(AuthenticationService.allownmsAdminMenus() ||
          AuthenticationService.allownmsMenus() ||
          AuthenticationService.allowAdminMenus()) && <>{renderNmsMenu()}</>}

        {AuthenticationService.allowDashboardConfigMenus() && (
          <>{renderDashboardConfigMenu()}</>
        )}
        {AuthenticationService.allowDashboardConfigMenus() && (
          <>{renderWidgetConfigMenu()}</>
        )}
        {AuthenticationService.allowkanAdminMenus() && (
          <>{renderKanAdminMenu()}</>
        )}
      </Grid>
      <CTLIfram
        handleClose={handleClose}
        openIfram={openIfram}
        entityName="Menu Dashboard"
        entityDescription={" "}
        url={pathUrl}
      />
    </MDBox>
  );
}

export default CTLMenuDashboard;
